import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { applicationUpload } from '../../../legacy/uploadApplication';
import icons from '../../../icons';
import { useFileDownloader } from "../../../hooks/useFileDownloader";
import { ContextMenu, MenuItem } from "../../../components/ContextMenu";
import { ApplicationTypes } from '../../../machinelogic/constants/ApplicationTypes';
import { Application, ApplicationBase, Library, User } from '@vse/machinelogic/types';

export interface ApplicationContextMenuProps {
  onApplicationRename: () => void;
  onApplicationUploaded: (app: Application) => void;
  library: Library;
  isRunning: boolean;
  onAppSelected?: ((app: ApplicationBase) => void) | undefined;
  applicationType: typeof ApplicationTypes[keyof typeof ApplicationTypes]
  user: User | undefined;
}

export const ApplicationContextMenu: FC<ApplicationContextMenuProps> = observer(({onApplicationRename, onApplicationUploaded, library, user, applicationType, isRunning}) => {
  const { download } = useFileDownloader();
  const currentApplication = library.currentApplication;
  const isMachineApp = currentApplication.mIsMachineApp;

  const isApplicationDownloadable = (): boolean => {
    if (user?.isAdmin) return true;
    return library.isVersionDownloadable();
  };

  const applications = applicationType == ApplicationTypes.MachineLogic ? library.getMachineLogicAppList() : library.getPythonAppList();

  let menuItems: MenuItem[];

  if (isMachineApp) {
    menuItems = [
      {
        text: 'Rename',
        icon: icons.edit,
        onClick: onApplicationRename
      }
    ];
  }
  else {
    menuItems = [
      {
        text: 'Rename',
        icon: icons.edit,
        disabled: !currentApplication || currentApplication.isReadOnly(),
        onClick: onApplicationRename
      },
      {
        text: 'Download',
        icon: icons.download,
        disabled: !isApplicationDownloadable(),
        onClick: () => {
          if (!currentApplication) { return; }
          const data = !currentApplication || currentApplication.getAsDownloadFormat();
          const robotAppsService =  currentApplication.mLibrary.getRobotAppsService();
          robotAppsService.send('MachineLogic/ApplicationContext/Download/onClick');
          download(data, `${currentApplication.name}.json`);
        }
      },
      {
        text: 'Upload App',
        icon: icons.upload,
        onClick: () => applicationUpload(library, (app) => {
          onApplicationUploaded(app);
        })
      },
      {
        text: 'Duplicate',
        icon: icons.copy,
        disabled: !currentApplication,
        onClick: () => {
          const newApp = library.copyApplication(currentApplication);
          library.selectApplication(newApp, true);
        }
      },
      {
        text: 'Create New',
        icon: icons.add_application,
        onClick: () => {
          const newApp = library.newApplication(applicationType);
          library.selectApplication(newApp, true);
        }
      },
      {
        text: 'Delete',
        icon: icons.removeCard,
        className: 'delete',
        disabled: !currentApplication || applications.length <= 1 || currentApplication.isReadOnly() || isMachineApp,
        onClick: () => library.removeApplication(currentApplication.id)
      },
    ];
  }

  return (
    <ContextMenu menuItems={menuItems} disabled={isRunning} />
  );
});

